import { useState } from "react";
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import ErrorMessage from "../components/shared/ErrorMessage.jsx";
import Logo from "../components/app/Logo.jsx";
import { applyTheme } from "../components/app/ThemeSelector.jsx";
import { login } from "../services/apiClient.js";
import { INSPECTION_HOME, isInspectionOnlyUser } from "../inspection/index.jsx";
import "../styles/login.css";

function LoginPage({ currentUser, setCurrentUser }) {
  const [username, setUsername] = useState("Robert Green");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  // ARCHIVE: fresh logins land on CLAIM SEARCH (Robert 2026-08-21), not the
  // dashboard live uses. Searching is the only thing anybody comes here to do
  // — every dashboard readout (logged/accepted targets, SLA turnaround,
  // marketing chases) measures live work that cannot exist in a frozen
  // estate. A bounced deep link still returns where the user was headed.
  const requestedDestination = location.state?.from?.pathname || "/claims/search";
  const destinationFor = (user) =>
    isInspectionOnlyUser(user) ? INSPECTION_HOME : requestedDestination;

  if (currentUser) {
    return <Navigate to={destinationFor(currentUser)} replace />;
  }

  async function handleSubmit(event) {
    event.preventDefault();
    setError("");

    try {
      const user = await login(username, password);
      setCurrentUser(user);
      applyTheme(user.theme);
      navigate(destinationFor(user), { replace: true });
    } catch (err) {
      setError(err.response?.data?.error || "Login failed.");
    }
  }

  return (
    <main className="login-page medispace-login">
      <form className="login-panel" onSubmit={handleSubmit}>
        <Logo variant="login" />
        <h1>Login</h1>
        <label htmlFor="username">Username</label>
        <input
          id="username"
          type="text"
          value={username}
          onChange={(event) => setUsername(event.target.value)}
          autoFocus
          required
        />
        <label htmlFor="password">Password</label>
        <input
          id="password"
          type="password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
          required
        />
        <ErrorMessage message={error} />
        <button type="submit">Login</button>
      </form>
    </main>
  );
}

export default LoginPage;
